module.exports = __webpack_public_path__ + "img/44cfe8f0a4623f4e558331605cd441f7.692288de.png";